import {
  FETCH_REFERRALDR_TYPES,
  FETCH_REFERRALDR_TYPES_SUCCESS,
  FETCH_REFERRALDR_TYPES_FAILED,
  EDIT_REFERRALDR_TYPE
} from "../store/types";

const INITIAL_STATE = {
  referraldrs: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const referralbrokersreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_REFERRALDR_TYPES:
      return {
        ...state,
        loading: true
      };
    case FETCH_REFERRALDR_TYPES_SUCCESS:
      return {
        ...state,
        referraldrs: action.payload,
        loading: false
      };
    case FETCH_REFERRALDR_TYPES_FAILED:
      return {
        ...state,
        referraldrs: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_REFERRALDR_TYPE:
      return state;
    default:
      return state;
  }
};